import pre from './pre';

import config from './config';
import cart from './cart.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    config,
    cart,
    success,
  },
};
